import React, { useState } from "react";
import {
  Button,
  Dialog,
  makeStyles,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@material-ui/core";
import { ReactComponent as RadioInvertedCheck } from "../../../../../assests/icons/RadioInvertedCheck.svg";


const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
    height: '100%',
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  header: {
    padding: '34px 28px 14px 28px',
    background: '#FFFFFF',
    flexShrink: 0,
  },
  title: {
    fontSize: '20px',
    fontFamily: 'Inter',
    color: '#1A2340',
    fontWeight: 600,
  },
  subText: {
    fontFamily: 'Inter',
    fontSize: '15px',
    color: '#6B7280'
  },
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '8px 28px 24px 28px',
    background: '#FFFFFF',
  },
  card: {
    background: '#FFFFFF',
    border: '1px solid #E3E6EF',
    borderRadius: '14px',
    padding: '26px 24px 30px 24px',
  },
  question: {
    marginBottom: '30px',
  },
  questionText: {
    fontSize: '18px',
    fontWeight: 400,
    color: '#1A2340',
    lineHeight: 1.4,
    marginBottom: '12px',
  },
  sectionText: {
    fontSize: '17px',
    fontWeight: 400,
    color: '#6A6F7D',
    lineHeight: 1.5,
    marginBottom: '4px',
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    flexWrap: 'wrap',
    marginTop: '2px',
  },
  radioLabel: {
    marginRight: '18px',
    '& .MuiFormControlLabel-label': {
      fontSize: '16px',
      color: '#111111',
      fontWeight: 300,
    },
  },
  errorMessage: {
    fontSize: '14px',
    color: '#D14343',
    lineHeight: 1.5,
    marginTop: '10px',
  },
  containerOfCrisis: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
}));

const IntakeNewModal = ({ intakeValues, intakeSetValues, isMobileView }) => {
  const classes = useStyles();
  const [showCrisis, setShowCrisis] = useState(false);

  const renderError = (fieldName) => {
    if (!intakeValues?.errors[fieldName] || !intakeValues?.touched[fieldName])
      return <></>;

    return (
      <Typography style={{ color: "red", marginTop: 5 }}>
        {intakeValues?.errors[fieldName]}
      </Typography>
    );
  };

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <Typography className={classes.title}>Intake Forms</Typography>
          <Typography className={classes.subtitle}>
            Please answer a few questions so your provider can prepare for your visit.
          </Typography>
        </div>

        <div className={classes.scrollArea}>
          <div className={classes.card}>
            <div className={classes.question}>
              <Typography className={classes.questionText}>
                Is patient a minor?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.minor}
                onChange={(event) => intakeSetValues('minor', event.target.value)}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="yes"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Yes"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="no"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="No"
                />
              </RadioGroup>
              {renderError('minor')}
            </div>

            <div className={classes.question}>
              <Typography className={classes.questionText}>
                Do you have any current or pending legal issues or are being advised by a
                court judge, parole officer, or CPS to seek mental health care or
                assessment?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.careOrAssessment}
                onChange={(event) =>
                  intakeSetValues('careOrAssessment', event.target.value)
                }
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="yes"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Yes"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="no"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="No"
                />
              </RadioGroup>
              {renderError('careOrAssessment')}
            </div>

            <div className={classes.question}>
              <Typography className={classes.sectionText}>
                Please select if you have ever experienced or suffered from any of the
                following in the past or present? <br />
                (check that applies)
              </Typography>
            </div>

            <div className={classes.question}>
              <Typography className={classes.questionText}>
                Have you had thoughts of harming yourself?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.harmingYourself}
                onChange={(event) => {
                  intakeSetValues('harmingYourself', event.target.value)
                  if (event?.target?.value === 'current') {
                    setShowCrisis(true)
                  }
                }}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="past"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Past"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="current"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Current"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="never"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Never"
                />
              </RadioGroup>
              {renderError('harmingYourself')}
            </div>

            <div className={classes.question}>
              <Typography className={classes.questionText}>
                Have you had thoughts of harming others?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.harmingOthers}
                onChange={(event) => {
                  intakeSetValues('harmingOthers', event.target.value)
                  if (event?.target?.value === 'current') {
                    setShowCrisis(true)
                  }
                }}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="past"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Past"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="current"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Current"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="never"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Never"
                />
              </RadioGroup>
              {renderError('harmingOthers')}
            </div>

            <div className={classes.question}>
              <Typography className={classes.questionText}>
                Have you struggled with alcohol abuse?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.alcoholAbuse}
                onChange={(event) =>
                  intakeSetValues('alcoholAbuse', event.target.value)
                }
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="past"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Past"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="current"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Current"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="never"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Never"
                />
              </RadioGroup>

              {intakeValues?.values?.alcoholAbuse === 'current' && (
                <Typography className={classes.errorMessage}>
                  TeleMed2U does not provide specialized treatment for Alcohol Use
                  Disorder. Our clinicians can support underlying behavioral health
                  needs, but we are unable to treat, manage, or prescribe for alcohol
                  misuse. For help with alcohol use, you can contact the SAMHSA
                  National Helpline at 1-800-662-HELP (4357), available 24/7. By
                  continuing, you acknowledge that you understand TeleMed2U cannot
                  treat Alcohol Use Disorder.
                </Typography>
              )}

              {renderError('alcoholAbuse')}
            </div>

            <div className={classes.question} style={{ marginBottom: 0 }}>
              <Typography className={classes.questionText}>
                Have you struggled with substance abuse?
              </Typography>

              <RadioGroup
                row
                value={intakeValues?.values?.substanceAbuse}
                onChange={(event) =>
                  intakeSetValues('substanceAbuse', event.target.value)
                }
                className={classes.radioGroup}
              >
                <FormControlLabel
                  className={classes.radioLabel}
                  value="past"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Past"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="current"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Current"
                />
                <FormControlLabel
                  className={classes.radioLabel}
                  value="never"
                  control={<Radio checkedIcon={<RadioInvertedCheck />} />}
                  label="Never"
                />
              </RadioGroup>

              {intakeValues?.values?.substanceAbuse === 'current' && (
                <>
                  <Typography className={classes.errorMessage}>
                    TeleMed2U does not provide specialized treatment for Substance Use
                    Disorders. Our clinicians can support underlying behavioral health
                    needs, but we cannot treat, manage, or prescribe for substance use.
                  </Typography>
                  <Typography className={classes.errorMessage}>
                    For support, you can contact the SAMHSA National Helpline at
                    1-800-662-HELP (4357), available 24/7.
                  </Typography>
                  <Typography className={classes.errorMessage}>
                    By continuing, you acknowledge that you understand TeleMed2U
                    cannot treat Substance Use Disorders.
                  </Typography>
                </>
              )}

              {renderError('substanceAbuse')}
            </div>
          </div>
        </div>
      </div>

      {/* Crisis Dialog */}
      <Dialog
        open={showCrisis}
        PaperProps={{
          style: {
            width: isMobileView ? 'unset' : '632px',
            maxWidth: isMobileView ? 'unset' : '632px',
            height: isMobileView ? 'unset' : '194px',
          },
        }}
      >
        <div className={classes.containerOfCrisis}>
          <div>
            <Typography className={classes.duplicatePatientHeader1}>
              If you are actively in crisis, please call or text 988 for the Suicide &
              Crisis Lifeline. TeleMed2U does not provide emergency or crisis
              services. By continuing, you acknowledge and consent that you understand
              TeleMed2U is not a crisis response provider.
            </Typography>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: isMobileView ? 'center' : 'flex-end',
            }}
          >
            <Button
              variant="contained"
              onClick={() => setShowCrisis(false)}
              style={{
                background: '#5473C9',
                textTransform: 'none',
                fontSize: '18px',
                fontWeight: 550,
                fontFamily: 'Inter',
              }}
            >
              <span>Continue</span>
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default IntakeNewModal;